const initialState = {
  index: [],
  selected: [],
  data: {},
};

const ContentSource = (state = initialState, action) => {
  switch (action.type) {
    case "CONTENT_SOURCE_INDEX":
      return { ...state, index: action.payload.index };
    case "CONTENT_SOURCE_SELECTED":
      return { ...state, selected: action.payload.selected };
    case "CONTENT_SOURCE_DATA":
      return { ...state, data: action.payload.data };
    case "CONTENT_SOURCE_RESET":
      return initialState;
    default:
      return state;
  }
};

export default ContentSource;
